import { useTranslation } from 'react-i18next'

import { GearIcon, SignOutIcon } from '@phosphor-icons/react'

import { AvatarLetters, ButtonMenu, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UserInfoMenu = ({ userInfo, onLogout, onEditProfile }) => {
  const { t } = useTranslation()
  return (
    <Styles.UserInfoContainer>
      <ButtonMenu
        stopPropagation
        header={
          <Styles.NameAndAlias>
            <Text type="bodyMBold">{userInfo?.full_name}</Text>
            <Text type="bodyMRegular">{userInfo?.username}</Text>
          </Styles.NameAndAlias>
        }
        menuItems={[
          {
            label: (
              <Styles.MenuItem>
                <GearIcon /> {t('Cuenta')}
              </Styles.MenuItem>
            ),
            onClick: () => onEditProfile(),
          },
          {
            label: (
              <Styles.MenuItem>
                <SignOutIcon /> {t('Salir')}
              </Styles.MenuItem>
            ),
            onClick: () => onLogout(),
          },
        ]}
        renderButton={onClick => (
          <Styles.UserInfo onClick={onClick} data-testid="userAvatar">
            {userInfo?.profile_picture_url ? (
              <Styles.Image src={userInfo?.profile_picture_url} />
            ) : (
              <AvatarLetters
                id={userInfo?.id}
                firstName={userInfo?.first_name}
                lastName={userInfo?.last_name}
                size="40px"
                textStyle="titleS"
              />
            )}
          </Styles.UserInfo>
        )}
      />
    </Styles.UserInfoContainer>
  )
}

export default UserInfoMenu
